const translations = {
  "en": {
    "Financial fitness score": "Financial fitness score"
  },
  "zh-tw": {
    "Financial fitness score": "財務健康分數"
  }
};

export default translations;
